import onElelementExistRunOnce from 'helpers/jquery/onElementExistRunOnce';

onElelementExistRunOnce('.agro_tasks_index_page', () => {
  import('./internal/agro_tasks_index_page').then(({ default: Component }) => Component());
});
